module.exports = {
	ENV: 'REPLACE_ME_ENV',
	URL: 'REPLACE_ME_URL',
	API: 'REPLACE_ME_API',
	SOCKET: '',
	PUBLICPATH: 'REPLACE_ME_PUBLICPATH',
	FORMPATH: 'REPLACE_ME_FORMPATH',
	LANDINGPAGEPATH: 'REPLACE_ME_LANDINGPAGEPATH',
	PRODUCT_NEWS_URL: '',
	CLASSIC_URL: '',
	STATIC_MAPS_KEY: 'AIzaSyBz8DCi-zXpKspt_-LTIlhu-0vbLYMTNOA',
	GOOGLE_FONTS_KEY: 'AIzaSyDRwD9bJV8XncXBSWG9SQxM0sHHPso5rbw',
	STATUSPAGE: {
		componentId: '1gr032v9zz1j'
	},
	PUSHER: {
		key: '0dae677b9a6736e36932',
		cluster: 'mt1'
	},
	SENTRY: {
		enable: true,
		env: 'awsbeta',
		dsn: 'https://663cd8ccd93c7e638afd8d022a941e70@sentry.upsales.com/2'
	},
	CHECKIN_URL: 'https://awsbeta-checkin.upsales.com/',
	CUSTOM_DOMAIN_CNAME: 'awsbetadomain.upsales.com',
	STATIC_URL: 'https://awsbetastatic.upsales.com/**',
	SPLIT_KEY: 'rm8te0f9kmkncbb2ideqotgprv1l0rhpt9cv',
	chatEnabled: true,
	GOOGLE_MAPS_KEY: 'AIzaSyBz8DCi-zXpKspt_-LTIlhu-0vbLYMTNOA',
	GOOGLE_MAPS_UPSALES_MAP_ID: 'df76eaf7634c8288',
	WORKFLOW_URL: 'https://n8n-beta.upsales.com',
	MAPBOX_TOKEN: 'pk.eyJ1IjoiZHdpa2JlcmciLCJhIjoiY21mbTd3M3ptMDVibDJscGUxeXJleXdxMyJ9.CyAyfqsNHZCYESUvc4iBug'
};
